import axios from "axios";
import localStorageService from "./localStorageService";
import { UserService } from "app/_services/UserService/UserService";
import toastr from "toastr";
class JwtAuthService {
  user = {
    userId: "1",
    role: "ADMIN",
    displayName: "Watson Joyce",
    email: "watsonjoyce@gmail.com",
    photoURL: "/assets/images/face-7.jpg",
    age: 25,
    token: "faslkhfh423oiu4h4kj432rkj23h432u49ufjaklj423h4jkhkjh",
  };

  loginWithEmailAndPassword = async (email, password, isMobile) => {
    let obj = {
      email: email,
      password: password,
      isMobile: isMobile,
    };

    // if (isMobile) {
    //   obj.isMobile = 1;
    // }

    let response = await UserService.login(obj);
    if (response.status === 401) {
      console.log("Entering");
      let path = window.location.pathname;
      path = path.split("/");
      toastr.error(response.message.error || "unauthorized");
      return response.message;
    }
    if (response && response.status && response.status !== 401) {
      let data = response.data;
      this.setSession(data.accessToken);
      this.setUser(data);

      localStorage.setItem("permissions", data.user.permissions);

      // localStorage.setItem("userPermissions", data.user.managePermissions);
      // localStorage.setItem("globalPermissions", data.user.globalPermissions);
      // localStorage.setItem("ehsPermissions", data.user.ehsPermissions)
      // localStorage.setItem("manageProjectPermissions", JSON.stringify(data.user.manageProjectPermissions))
      return data;
    } else if (response.message) {
      throw new Error(JSON.stringify(response.message)); // rejects the promise
    }
  };

  loginWithToken = () => {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve(this.user);
      }, 100);
    }).then((data) => {
      this.setSession(data.token);
      this.setUser(data);
      return data;
    });
  };

  logout = () => {
    this.setSession(null);
    this.removeUser();
  };

  setSession = (token) => {
    if (token) {
      localStorage.setItem("jwt_token", token);
      axios.defaults.headers.common["Authorization"] = "Bearer " + token;
    } else {
      localStorage.removeItem("jwt_token");
      delete axios.defaults.headers.common["Authorization"];
    }
  };
  setUser = (user) => {
    localStorageService.setItem("auth_user", user);
  };
  removeUser = () => {
    localStorage.removeItem("auth_user");
    localStorage.removeItem("siteIds");
    localStorage.removeItem("permissions");
    localStorage.removeItem("employeeListData");
    localStorage.removeItem("contractorPersonListData");
    localStorage.removeItem("contractorListData");
  };
}

export default new JwtAuthService();
